import React, { createContext, useContext, useState } from "react";
import {sitesDataState}  from './appState';

export const SitesContext = createContext();
export const useSitesContext = () => useContext(SitesContext);

export const SitesContextProvider = (props) => {
    const [appState, setAppState] = useState(sitesDataState);

    const setSitesData = (sitesData = []) => {
        setAppState({
            ...appState,
            sitesData: sitesData
        })
    }


    return (
        <SitesContext.Provider value={{
            appState, setAppState,setSitesData
        }} >
            {props.children}
        </SitesContext.Provider>
    );

}
